import {
  Box,
  Button,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { currencyFormat, DEFAULT_TOAST_DURATION, SalesTypeList } from "@kg-pos/common";
import { TitleRewardDataFragment, useDeleteTitleRewardMutation } from "__generated__/graphql";
import dayjs from "dayjs";
import { useParams } from "hooks/useParams";
import { useState } from "react";
import { DeleteModal } from "../delete-modal";
import { TitleRewardModal } from "../title-reward-modal";

type TitleRewardProps = {
  titleRewards: TitleRewardDataFragment[];
  refetch: any;
};

export const TitleReward = ({ titleRewards, refetch }: TitleRewardProps) => {
  const id = useParams();
  const [deleteTitleReward] = useDeleteTitleRewardMutation();
  const titleRewardModal = useDisclosure();
  const [titleReward, setTitleReward] = useState<TitleRewardDataFragment | null>(null);
  const toast = useToast();

  const handleDeleteTitleReward = async (titleRewardId: string): Promise<boolean> => {
    return !!(await deleteTitleReward({ variables: { id: titleRewardId } })).data
      ?.deleteTitleReward;
  };

  return (
    <>
      <Box fontWeight="bold" mb={5}>
        役職手当
        <Button
          ml={3}
          colorScheme="blue"
          onClick={() => {
            setTitleReward(null);
            titleRewardModal.onOpen();
          }}
        >
          追加
        </Button>
      </Box>

      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>内容</Th>
            <Th>適用開始年月</Th>
            <Th>適用終了年月</Th>
            <Th>操作</Th>
          </Tr>
        </Thead>
        <Tbody>
          {titleRewards?.map((titleReward) => (
            <Tr key={titleReward.id}>
              <Td>
                {(titleReward.amount > 0 ||
                  (titleReward.amount === 0 && titleReward.percentage === 0)) && (
                  <Text>固定金額：{currencyFormat(titleReward.amount)}</Text>
                )}
                {titleReward.percentage > 0 && (
                  <Text>
                    パーセンテージ：{SalesTypeList[titleReward.salesType]} ×{" "}
                    {titleReward.percentage}%
                  </Text>
                )}
              </Td>
              <Td>{dayjs(titleReward.startMonth).format("YYYY年MM月")}</Td>
              <Td>{!!titleReward.endMonth && dayjs(titleReward.endMonth).format("YYYY年MM月")}</Td>
              <Td>
                <Button
                  mr={3}
                  onClick={() => {
                    setTitleReward(titleReward);
                    titleRewardModal.onOpen();
                  }}
                >
                  編集
                </Button>
                <DeleteModal
                  title="役職手当削除"
                  name="役職手当"
                  buttonText="削除"
                  close={true}
                  handleDelete={async () => {
                    if (await handleDeleteTitleReward(titleReward.id)) {
                      toast({
                        title: `削除しました。`,
                        status: "success",
                        duration: DEFAULT_TOAST_DURATION,
                        isClosable: true,
                      });
                    } else {
                      toast({
                        title: `削除に失敗しました。`,
                        status: "error",
                        duration: DEFAULT_TOAST_DURATION,
                        isClosable: true,
                      });
                    }
                    await refetch();
                  }}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      {titleRewardModal.isOpen && (
        <TitleRewardModal
          isOpen={titleRewardModal.isOpen}
          onClose={titleRewardModal.onClose}
          hostId={id}
          data={titleReward}
          refetch={refetch}
        />
      )}
    </>
  );
};
